import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        marginBottom: 20,
    },
    sectionHeader: {
        fontSize: 16,
        color: '#004899',
        fontWeight: 'bold',
        marginBottom: 10,
        backgroundColor: '#f8f9fa',
        padding: 8,
        borderRadius: 4,
        borderLeftWidth: 3,
        borderLeftColor: '#004899',
    },
    usersContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
    },
    userBadge: {
        marginBottom: 8,
        marginRight: 8,
        padding: 8,
        borderRadius: 6,
        borderWidth: 1,
        maxWidth: '30%',
        minWidth: 120,
    },
    ownerBadge: {
        backgroundColor: '#004899',
        borderColor: '#004899',
    },
    regularBadge: {
        backgroundColor: 'white',
        borderColor: '#004899',
    },
    ownerText: {
        color: 'white',
        fontSize: 10,
        fontWeight: 'bold',
    },
    regularText: {
        color: '#004899',
        fontSize: 10,
        fontWeight: 'bold',
    },
    roleContainer: {
        marginTop: 4,
        flexDirection: 'row',
    },
    roleBadge: {
        borderRadius: 10,
        padding: 4,
        paddingHorizontal: 6,
        marginRight: 4,
    },
    ownerRoleBadge: {
        backgroundColor: '#003d8a',
        borderWidth: 1,
        borderColor: 'white',
    },
    regularRoleBadge: {
        backgroundColor: '#EDF5FF',
        borderWidth: 1,
        borderColor: '#d9e6ff',
    },
    ownerRoleText: {
        color: 'white',
        fontSize: 8,
    },
    regularRoleText: {
        color: '#004899',
        fontSize: 8,
    },
    noUsersText: {
        fontSize: 10,
        color: '#666',
        fontStyle: 'italic',
    }
});

interface User {
    id: number;
    name: string;
    email?: string;
    role?: string;
}

interface ProjectUsersSectionProps {
    creatorId: number;
    users: User[];
}

export const ProjectUsersSection: React.FC<ProjectUsersSectionProps> = ({ creatorId, users }) => {
    // Combine creator and users, removing duplicates
    // const allUsers = [ ...users.filter(user => user.id !== creator.id)];
    console.log(users,'users in proejcts section',creatorId)
    return (
        <View style={styles.container}>
            <Text style={styles.sectionHeader}>Project Users</Text>

            {users.length > 0 ? (
                <View style={styles.usersContainer}>
                    {users.map((user, index) => {
                        const isOwner = user.id === creatorId
                        const isAdmin = user.role && user.role.toLowerCase().includes('admin');

                        return (
                            <View
                                key={`user-${index}`}
                                style={[
                                    styles.userBadge,
                                    isOwner ? styles.ownerBadge : styles.regularBadge
                                ]}
                            >
                                <Text style={isOwner ? styles.ownerText : styles.regularText}>
                                    {user.name || 'User'}
                                </Text>

                                <View style={styles.roleContainer}>
                                    {isOwner && (
                                        <View style={[styles.roleBadge, styles.ownerRoleBadge]}>
                                            <Text style={styles.ownerRoleText}>Owner</Text>
                                        </View>
                                    )}

                                    {user.role && (
                                        <View style={[styles.roleBadge, isOwner ? styles.ownerRoleBadge : styles.regularRoleBadge]}>
                                            <Text style={isOwner ? styles.ownerRoleText : styles.regularRoleText}>
                                                {user.role}
                                            </Text>
                                        </View>
                                    )}
                                </View>
                            </View>
                        );
                    })}
                </View>
            ) : (
                <Text style={styles.noUsersText}>No users added to this project yet.</Text>
            )}
        </View>
    );
}; 